<style scoped lang="scss">
    @import '~@/abstracts/_variables.scss';

    div#order-service-page {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: white;
        z-index: 9999;
        overflow: auto;

        img#back {
            float: right;
            margin-top: 20px;
            margin-right: 20px;
        }

        div.close-block {
            top: 0.5rem;
            right: 0.5rem;
            position: absolute;

            a.close-block-button {
                justify-content: center;
                align-items: center;
                display: inline-flex;
                border-radius: 0.375rem;
                outline: 2px solid transparent;
                outline-offset: 2px;
                color: rgb(156, 163, 175);
                padding: 0.5rem;

                svg {
                    width: 2.5rem;
                    height: 2.5rem;
                }

                &:hover {
                    background-color: rgb(243, 244, 246);
                    color: rgb(107, 114, 128);
                }
            }
        }

        .centered {
            margin: auto;
        }

        span.development-label {
            position: absolute;
            font-family: 'Raleway', sans-serif;
            font-size: 16px;
            color: #fff;
            background-color: #dc3545;
            padding: 0.25rem 0.875rem;
            border-radius: 5px;
            font-weight: bold;
            float: left;
            margin-top: 22px;
            margin-left: 10px;
        }

        h2.page-title {
            display: block;
            color: $secondary-color;
            font-size: 36px;
            font-weight: bold;
            font-family: 'Raleway', sans-serif;
            margin-top: 60px;
            text-align: center;
        }

        h5.section-title {
            font-family: 'Raleway', sans-serif;
            font-weight: bold;
            text-align: center;
            margin-bottom: 20px;
            margin-top: 20px;
        }

        span.service-title {
            display: block;
            color: #342C0C;
            font-size: 26px;
            font-weight: bold;
            font-family: 'Raleway', sans-serif;
            margin-top: 20px;
            text-align: center;
        }

        label.form-label {
            font-family: 'Raleway', sans-serif;
            font-weight: bold;
            text-align: left;
            color: black;
            margin-top: 10px;
            margin-bottom: 0;

            &.required:after {
                color: red;
                content: " *";
            }
        }

        input[type="text"].form-input {
            font-family: 'Raleway', sans-serif;
            border: 1px solid #BABABA;
            border-radius: 3px;

            &.invalid{
                border: 1px solid #D0021B;
            }
        }

        input[type="date"].form-input {
            font-family: 'Raleway', sans-serif;
            border: 1px solid #BABABA;
            border-radius: 3px;

            &.invalid{
                border: 1px solid #D0021B;
            }
        }

        span.selected-slot-text {
            display: block;
            font-family: 'Raleway', sans-serif;
            text-align: center;
            font-weight: bold;
        }

        div.validation {
            color: #D0021B;
            font-family: 'Raleway', sans-serif;
            font-size: 14px;
            margin-top: -15px;
            margin-bottom: 15px;
            text-align: left;
        }

        span.bottom-security-text {
            display: block;
            font-family: 'Raleway', sans-serif;
            color: #666666;
            font-style: italic;
            padding: 20px;

            a {
                color: $secondary-color;
            }

            .mandatory {
                color: red;
                font-size: 22px;
            }
        }

        a.order-button {
            display: block;
            text-align: center;
            height: 50px;
            color: white;
            border-radius: 5px;
            font-size: 16px;
            font-weight: 700 !important;
            font-family: 'Raleway', sans-serif;
            background-color: $secondary-color;
            -webkit-appearance: none;
            transition: color .2s cubic-bezier(0.55, 0.085, 0.68, 0.53),box-shadow .2s cubic-bezier(0.55, 0.085, 0.68, 0.53),background-color .2s cubic-bezier(0.55, 0.085, 0.68, 0.53);
            border: none;
            line-height: 50px;
            margin-bottom: 60px;
            margin-top: 20px;

            &:hover {
                background-color: #810050;
            }
        }
    }

    /* Small only */
    @media screen and (max-width: 39.9375em) {
        div#order-service-page {
            span.development-label {
                display: none;
            }

            h2.page-title {
                font-size: 25px;
            }
        }
    }
</style>

<template>
    <transition name="scale-in-center">
        <div id="order-service-page">
            <span class="development-label" v-if="app_env == 'local' || app_env == 'development'">
                Testovací prostředí
            </span>

            <div class="close-block">
                <a v-on:click="closeModal()" class="close-block-button">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                </a>
            </div>

            <div class="grid-container">
                <div class="grid-x grid-padding-x">
                    <div class="large-8 medium-9 small-12 cell centered">
                        <h2 class="page-title" v-if="serviceLoadStatus == 2">{{ $t('order.titleInspector') }}</h2>
                        <span class="service-title" v-if="serviceLoadStatus == 2">{{ serviceName }}</span>
                    </div>
                </div>

                <loader v-show="serviceLoadStatus == 0 || serviceLoadStatus == 1" :width="100" :height="100"></loader>

                <div class="grid-x grid-padding-x" v-if="serviceLoadStatus == 2">
                    <div class="large-8 medium-9 small-12 cell centered">
                        <div class="grid-x grid-padding-x">
                            <div class="large-6 medium-6 small-12 cell">
                                <label class="form-label">{{ $t('order.licensePlate') }}</label>
                                <input type="text" class="form-input" v-model="license" readonly />
                            </div>
                            <div class="large-6 medium-6 small-12 cell">
                                <label class="form-label required">{{ $t('order.mileage') }}</label>
                                <input type="text" v-on:keypress="validNumber" @paste.prevent v-model="mileage" ref="mileage" maxlength="7" v-bind:class="{ 'invalid' : !validations.mileage.is_valid }" class="form-input" />
                                <div class="validation" v-show="!validations.mileage.is_valid">{{ validations.mileage.text }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid-x grid-padding-x" v-if="serviceLoadStatus == 2">
                    <div class="large-8 medium-9 small-12 cell centered">
                        <h5 class="section-title">{{ $t('order.contactSectionLabel') }}</h5>

                        <div class="grid-x grid-padding-x">
                            <div class="large-6 medium-6 small-12 cell">
                                <label class="form-label required">{{ $t('order.firstName') }}</label>
                                <input type="text" v-model="firstName" ref="firstName" v-bind:class="{ 'invalid' : !validations.firstName.is_valid }" class="form-input" />
                                <div class="validation" v-show="!validations.firstName.is_valid">{{ validations.firstName.text }}</div>
                            </div>
                            <div class="large-6 medium-6 small-12 cell">
                                <label class="form-label required">{{ $t('order.lastName') }}</label>
                                <input type="text" v-model="lastName" ref="lastName" v-bind:class="{ 'invalid' : !validations.lastName.is_valid }" class="form-input" />
                                <div class="validation" v-show="!validations.lastName.is_valid">{{ validations.lastName.text }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid-x grid-padding-x" v-if="serviceLoadStatus == 2">
                    <div class="large-8 medium-9 small-12 cell centered">
                        <div class="grid-x grid-padding-x">
                            <div class="large-6 medium-6 small-12 cell">
                                <label class="form-label required">{{ $t('order.email') }}</label>
                                <input type="text" v-model="emailAddress" ref="emailAddress" v-bind:class="{ 'invalid' : !validations.emailAddress.is_valid }" class="form-input" />
                                <div class="validation" v-show="!validations.emailAddress.is_valid">{{ validations.emailAddress.text }}</div>
                            </div>
                            <div class="large-6 medium-6 small-12 cell">
                                <label class="form-label required">{{ $t('order.phone') }}</label>
                                <VuePhoneNumberInput v-model="phoneNumber" @update="onUpdatePhoneNumber" maxlength="11" color="#c8017d" default-country-code="CZ" required :only-countries="phoneNumberOnlyCountries" :translations="phoneNumberTranslations" />
                                <div class="validation" v-show="!validations.phoneNumber.is_valid">{{ validations.phoneNumber.text }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid-x grid-padding-x" v-if="serviceLoadStatus == 2 && this.service.maintenance_slot == true">
                    <div class="large-8 medium-9 small-12 cell centered" style="margin-bottom: 100px;">
                        <div class="grid-x grid-padding-x">
                            <div class="large-12 medium-12 small-12 cell">
                                <h5 class="section-title">{{ $t('order.selectionDateSectionLabel') }}</h5>

                                <div class="validation" style="text-align: center;" v-show="!validations.selectedSlot.is_valid">{{ validations.selectedSlot.text }}</div>

                                <loader v-show="serviceSlotsLoadStatus == 1" :width="100" :height="100"></loader>

                                <vue-cal v-if="serviceSlotsLoadStatus == 2"
                                         ref="vuecal"
                                         :locale="$i18n.locale"
                                         hide-view-selector
                                         active-view="week"
                                         :disable-views="['years', 'year', 'month', 'day']"
                                         :time="false"
                                         :events="events"
                                         @event-focus="onEventFocus">
                                    <!--
                                    <template v-slot:weekday-heading="param">{{ param }}</template>
                                    -->

                                    <template v-slot:title="{ title, view }">
                                        {{ title }}
                                    </template>

                                    <template v-slot:arrow-prev>
                                        <span v-on:click="clickedPrevCal()">&nbsp;<i class="angle"></i>&nbsp;</span>
                                    </template>

                                    <template v-slot:arrow-next>
                                        <span v-on:click="clickedNextCal()">&nbsp;<i class="angle"></i>&nbsp;</span>
                                    </template>

                                    <template v-slot:weekday-heading="{ heading }">{{ heading.label.substring(0, 2) }} {{ heading.date.format('DD. MM.') }}</template>

                                    <template v-slot:event="{ event, view }">
                                        <div class="vuecal__event-title" :class="'slot-' + event.id"  :id="'slot-' + event.id" :ref="'slot-' + event.id" v-html="event.title + '<span>' + event.subtitle + '</span>'" />
                                    </template>
                                </vue-cal>
                            </div>
                        </div>
                    </div>

                    <div class="large-8 medium-9 small-12 cell centered">
                        <div class="grid-x grid-padding-x">
                            <div class="large-12 medium-12 small-12 cell">
                                <span class="selected-slot-text" v-if="this.selectedEvent.id">
                                    {{ $t('order.selectionDateSectionSelectedSlotFirst') }} {{ formatDate(this.selectedEvent.start) }} {{ $t('order.selectionDateSectionSelectedSlotSecond') }} {{ serviceSlotReservationTime }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid-x grid-padding-x" v-if="serviceLoadStatus == 2">
                    <div class="large-8 medium-9 small-12 cell centered">
                        <div class="grid-x grid-padding-x">
                            <div class="large-12 medium-12 small-12 cell">
                                <span class="bottom-security-text">
                                    {{ $t('order.securityInfoFirst') }} <a :href="$t('order.securityInfoLink')" target="_blank">{{ $t('order.securityInfoSecond') }}</a>.
                                    <br />
                                    {{ $t('order.mandatoryInfoFirst') }} <span class="mandatory">*</span> {{ $t('order.mandatoryInfoSecond') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid-x grid-padding-x" v-if="serviceLoadStatus == 2">
                    <div class="large-4 medium-5 small-12 cell centered">
                        <loader v-show="orderInspectionFormSentStatus == 1" :width="100" :height="100"></loader>
                        <a class="order-button" v-show="orderInspectionFormSentStatus != 1" v-on:click="submitOrderInspector()">{{ $t('order.submitFormButton') }}</a>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import moment from 'moment'
    import API from "../api/service";
    import Geocode from "../api/geocode";
    import Loader from "../components/global/Loader";
    import VueCal from 'vue-cal'
    import 'vue-cal/dist/vuecal.css'
    import 'vue-cal/dist/i18n/cs.js'
    import Vue from "vue";
    import VuePhoneNumberInput from 'vue-phone-number-input';
    import 'vue-phone-number-input/dist/vue-phone-number-input.css';
    import {EventBus} from "../event-bus";
    import {ROAST_CONFIG} from "../config";

    export default {
        components: {
            Loader,
            VueCal,
            VuePhoneNumberInput
        },

        data() {
            return {
                momentFormat: {
                    // Date to String
                    stringify: (date) => {
                        return date ? moment(date).format('DD.MM.YYYY') : ''
                    },
                    // String to Date
                    parse: (value) => {
                        return value ? moment(value, 'DD.MM.YYYY').toDate() : null
                    }
                },

                app_env: ROAST_CONFIG.APP_ENV,

                enabledSlotReservationCounter: false,
                slotReservationCountdown: moment(180 * 10 * 1000),

                selectedEvent: {},
                events: [],

                serviceName: '',

                license: '',
                mileage: '',
                firstName: '',
                lastName: '',
                emailAddress: '',

                phoneNumber: '',
                phoneNumberResults: {},
                phoneNumberOnlyCountries: ['CZ', 'SK'],
                phoneNumberTranslations: {
                    countrySelectorLabel: this.$t('order.phoneCountryCode'),
                    countrySelectorError: this.$t('order.phoneSelectCountry'),
                    phoneNumberLabel: this.$t('order.phoneNumberPlaceholder'),
                    example: this.$t('order.phoneNumberExample')
                },

                slotDefinition: false,

                validations: {
                    mileage: {
                        is_valid: true,
                        text: ''
                    },
                    firstName: {
                        is_valid: true,
                        text: ''
                    },
                    lastName: {
                        is_valid: true,
                        text: ''
                    },
                    emailAddress: {
                        is_valid: true,
                        text: ''
                    },
                    phoneNumber: {
                        is_valid: true,
                        text: ''
                    },
                    selectedSlot: {
                        is_valid: true,
                        text: ''
                    }
                }
            }
        },

        mounted() {
            this.$selectedSlot = null;
            this.$selectedSlotId = null;
            this.$selectedSlotDate = null;
        },

        created() {
            if (this.clientLocation) {
                this.loadService();
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(position => {
                        this.setClientLocation(position);
                    }, err => {
                        console.log('User denied Geolocation');
                        this.$router.push({ name: 'services' });
                    }, {
                        enableHighAccuracy: true,
                        timeout: 60000
                    });
                }
            }
        },

        computed: {
            clientLocation() {
                return this.$store.getters.getClientLocation;
            },

            licensePlate() {
                return this.$store.getters.getLicensePlate;
            },

            clientPersonalData() {
                return this.$store.getters.getClientPersonalData;
            },

            workroom() {
                return this.$store.getters.getWorkroom;
            },

            makeId() {
                return this.$store.getters.getMakeId;
            },

            distance() {
                return this.$store.getters.getDistanceFilter;
            },

            serviceLoadStatus() {
                return this.$store.getters.getServiceLoadStatus;
            },

            service() {
                return this.$store.getters.getService;
            },

            serviceSlotDefinition() {
                return this.$store.getters.getServiceSlotDefnition;
            },

            serviceSlots() {
                return this.$store.getters.getServiceSlots;
            },

            serviceSlotsLoadStatus() {
                return this.$store.getters.getServiceSlotsLoadStatus;
            },

            serviceBlockSlotLoadStatus() {
                return this.$store.getters.getBlockServiceSlotLoadStatus;
            },

            serviceSlotBlockUntil() {
                return this.$store.getters.getBlockServiceSlotUntil;
            },

            orderInspectionFormSentStatus() {
                return this.$store.getters.getOrderInspectionFormSentStatus;
            },

            serviceSlotReservationTime: function() {
                return this.slotReservationCountdown.format('mm:ss');
            }
        },

        watch: {
            'serviceLoadStatus': function() {
                if (this.serviceLoadStatus == 2) {
                    this.loadServiceSlotDefinition();
                    this.loadServiceSlots();
                    this.populateForm();
                }
            },

            'serviceSlotsLoadStatus': function() {
                if (this.serviceSlotsLoadStatus == 2) {
                    this.serviceSlots.forEach((value, index) => {
                        this.events.push(value);
                        //this.customEventCreation(value);
                    });
                }
            },

            'serviceBlockSlotLoadStatus' : function () {
                if (this.serviceBlockSlotLoadStatus == 2) {
                    //this.slotReservationCountdown = moment(this.serviceSlotBlockUntil * 1000);
                } else if (this.serviceBlockSlotLoadStatus == 3) {
                    this.$store.dispatch('flashMessageShow', { type: 'info', message: this.$t('order.selectionDateSectionAlreadyReserved') }, { root: true })

                    this.selectedEvent = {};
                    this.events = [];
                    this.$selectedSlot = null;
                    this.$selectedSlotId = null;
                    this.$selectedSlotDate = null;

                    this.loadServiceSlots();
                }
            },

            'selectedEvent': function() {
                // event selected
            },

            'slotReservationCountdown': function() {
                if (this.serviceSlotReservationTime == '00:00') {
                    this.selectedEvent = {};
                    this.events = [];
                    this.$selectedSlot = null;
                    this.$selectedSlotId = null;
                    this.$selectedSlotDate = null;

                    this.loadServiceSlots();
                }
            },

            'orderInspectionFormSentStatus': function() {
                if (this.orderInspectionFormSentStatus == 2) {
                    localStorage.clear();

                    this.$store.commit('setDistanceFilter', 10);
                    this.$store.commit('setClientCurrentLocation', '');
                    this.$store.commit('setServices', []);
                    this.$store.commit('setLicensePlate', null);
                    this.$store.commit('setClientPersonalData', null);

                    this.$store.dispatch('flashMessageShow', { type: 'success', message: this.$t('order.successInspectionFormSubmit') }, { root: true })

                    this.$router.push({ name: 'login' });
                } else if (this.orderInspectionFormSentStatus == 3) {
                    this.$store.dispatch('flashMessageShow', { type: 'error', message: this.$t('order.errorFormSubmit') }, { root: true })
                } else if (this.orderInspectionFormSentStatus == 4) {
                    this.$store.dispatch('flashMessageShow', { type: 'error', message: this.$t('order.conflictFormSubmit') }, { root: true })
                }
            },
        },

        methods: {
            setClientLocation(position) {
                Geocode.getCountryCodeFromPosition(position)
                    .then((response) => {
                        if (response != 'CZ') {
                            this.$store.commit('setClientCurrentLocation', { location: { latitude: 50.08804, longitude: 14.42076 } })
                        } else {
                            this.$store.commit('setClientCurrentLocation', { location: { latitude: position.coords.latitude, longitude: position.coords.longitude } })
                        }

                        this.loadService();
                    })
                    .catch((error) => {
                        console.log(error)
                    });
            },

            loadService() {
                this.$store.dispatch('loadService', {
                    slug: this.$route.params.slug,
                    distance: this.distance,
                    workroom: this.workroom,
                    makeId: this.makeId,
                    licensePlate: this.licensePlate,
                    latitude: this.clientLocation.latitude,
                    longitude: this.clientLocation.longitude
                });
            },

            loadServiceSlotDefinition() {
                this.$store.commit('setServiceSlotDefinition', {});

                if (this.service.maintenance_slot) {
                    this.$store.dispatch('loadServiceSlotDefinition', {
                        workroom_id: this.service.workroom_id
                    });

                    this.slotDefinition = true;
                }
            },

            loadServiceSlots() {
                this.$store.commit('setServiceSlots', []);

                if (this.service.maintenance_slot) {
                    this.$store.dispatch('loadServiceSlots', {
                        workroom_id: this.service.workroom_id,
                        workroom: this.workroom
                    });
                }
            },

            populateForm() {
                this.serviceName = this.service.name;
                this.serviceWorkroomId = this.service.workroom_id;
                this.license = this.licensePlate;

                this.firstName = this.clientPersonalData ? this.clientPersonalData.first_name : '';
                this.lastName = this.clientPersonalData ? this.clientPersonalData.last_name : '';
                this.emailAddress = this.clientPersonalData ? this.clientPersonalData.email : '';
                this.phoneNumber = this.clientPersonalData ? this.clientPersonalData.phone : '';
            },

            submitOrderInspector() {
                if (this.validateOrderInspection()) {
                    this.$store.dispatch('orderInspection', {
                        serviceWorkroomId: this.serviceWorkroomId,
                        serviceName: this.serviceName,
                        selectedSlot: this.$selectedSlot,
                        selectedEvent: this.selectedEvent,
                        clientLocation: this.clientLocation,
                        preferredLanguage: this.$i18n.locale,
                        licensePlate: this.licensePlate,
                        mileage: this.mileage,
                        firstName: this.firstName,
                        lastName: this.lastName,
                        emailAddress: this.emailAddress,
                        phoneNumber: this.phoneNumber,
                        phoneNumberPrefix: this.phoneNumberResults.countryCallingCode,
                        service: this.service,
                        serviceSlotDefinition: this.serviceSlotDefinition
                    });
                }
            },

            validateOrderInspection() {
                let validOrderServiceForm = true;

                if (this.mileage.trim() == '') {
                    validOrderServiceForm = false;
                    this.validations.mileage.is_valid = false;
                    this.validations.mileage.text = this.$t('order.mileageValidation');
                    this.$refs['mileage'].focus();
                } else {
                    this.validations.mileage.is_valid = true;
                    this.validations.mileage.text = '';
                }

                if (this.firstName.trim() == '') {
                    validOrderServiceForm = false;
                    this.validations.firstName.is_valid = false;
                    this.validations.firstName.text = this.$t('order.firstNameValidation');
                    this.$refs['firstName'].focus();
                } else {
                    this.validations.firstName.is_valid = true;
                    this.validations.firstName.text = '';
                }

                if (this.lastName.trim() == '') {
                    validOrderServiceForm = false;
                    this.validations.lastName.is_valid = false;
                    this.validations.lastName.text = this.$t('order.lastNameValidation');
                    this.$refs['lastName'].focus();
                } else {
                    this.validations.lastName.is_valid = true;
                    this.validations.lastName.text = '';
                }

                if (this.emailAddress.trim() == '') {
                    validOrderServiceForm = false;
                    this.validations.emailAddress.is_valid = false;
                    this.validations.emailAddress.text = this.$t('order.emailValidation');
                    this.$refs['emailAddress'].focus();
                } else {
                    if (!this.validEmail(this.emailAddress.trim())) {
                        validOrderServiceForm = false;
                        this.validations.emailAddress.is_valid = false;
                        this.validations.emailAddress.text = this.$t('order.emailValidationFormat');
                        this.$refs['emailAddress'].focus();
                    } else {
                        this.validations.emailAddress.is_valid = true;
                        this.validations.emailAddress.text = '';
                    }
                }

                if (this.phoneNumber == '' || this.phoneNumber == null) {
                    validOrderServiceForm = false;
                    this.validations.phoneNumber.is_valid = false;
                    this.validations.phoneNumber.text = this.$t('order.phoneValidation');
                } else {
                    if (this.phoneNumber.replace(/\s/g, '').length < 9 || this.phoneNumberResults.isValid == false) {
                        validOrderServiceForm = false;
                        this.validations.phoneNumber.is_valid = false;
                        this.validations.phoneNumber.text = this.$t('order.phoneValidationFormat');
                        this.$refs['emailAddress'].focus();
                    } else {
                        this.validations.phoneNumber.is_valid = true;
                        this.validations.phoneNumber.text = '';
                    }
                }

                if (this.service.maintenance_slot) {
                    if (this.$selectedSlot == null) {
                        validOrderServiceForm = false;
                        this.validations.selectedSlot.is_valid = false;
                        this.validations.selectedSlot.text = this.$t('order.selectionDateSectionValidation');
                    } else {
                        this.validations.selectedSlot.is_valid = true;
                        this.validations.selectedSlot.text = '';
                    }
                }

                if (!validOrderServiceForm) {
                    this.$store.dispatch('flashMessageShow', { type: 'info', message: this.$t('order.warningFormSubmit') }, { root: true })
                }

                return validOrderServiceForm;
            },

            validNumber(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;

                if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },

            validEmail(email) {
                //var regExprEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                var regExprEmail = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

                return regExprEmail.test(email);
            },

            clearForm() {
                this.serviceName = '';
                this.serviceID = '';
                this.mileage = '';
                this.firstName = '';
                this.lastName = '';
                this.emailAddress = '';
                this.phoneNumber = '';

                this.validations = {
                    mileage: {
                        is_valid: true,
                        text: ''
                    },
                    firstName: {
                        is_valid: true,
                        text: ''
                    },
                    lastName: {
                        is_valid: true,
                        text: ''
                    },
                    emailAddress: {
                        is_valid: true,
                        text: ''
                    },
                    phoneNumber: {
                        is_valid: true,
                        text: ''
                    },
                    selectedSlot: {
                        is_valid: true,
                        text: ''
                    }
                };
            },

            formatDate(value) {
                if (value) {
                    return moment(new Date(value)).format('DD. MM. YYYY')
                }
            },

            closeModal() {
                if (this.$selectedSlot) {
                    var refsItem = this.$refs['slot-' + this.$selectedSlotId];

                    if (refsItem) {
                        refsItem.classList.remove('selected_event');
                    }

                    this.$store.dispatch('unblockServiceSlot', {
                        slot_id: this.$selectedSlot
                    });
                }

                this.$router.push({ name: 'services' });
            },

            onEventClick(event, e) {
                this.selectedEvent = event;

                if (this.$selectedSlot) {
                    var refsItem = this.$refs['slot-' + this.$selectedSlot];

                    if (refsItem) {
                        refsItem.classList.remove('selected_event');
                    }

                    this.$store.dispatch('unblockServiceSlot', {
                        slot_id: this.$selectedSlot
                    });

                    this.slotReservationCountdown = moment(180 * 10 * 1000);
                }

                this.$selectedSlot = event.id;

                this.$refs['slot-' + event.id].classList.add('selected_event');

                this.$store.dispatch('blockServiceSlot', {
                    slot_id: this.$selectedSlot
                });

                this.slotReservationCountdown = moment(180 * 10 * 1000);

                if (!this.enabledSlotReservationCounter) {
                    setInterval(() => {
                        this.slotReservationCountdown = moment(this.slotReservationCountdown.subtract(1, 'seconds'))
                    }, 1000);

                    this.enabledSlotReservationCounter = true;
                }

                e.stopPropagation();
            },

            onEventFocus(event, e) {
                this.selectedEvent = event;

                /*
                var vueCallCells = document.querySelectorAll(".vuecal__cell");
                var myArray = Array.from(vueCallCells);

                function getKeyByValue(object, value) {
                  return Object.keys(object).find(key => object[key] === value);
                }

                setTimeout(() => {
                  var vueCallCellsSelected = document.querySelector(".vuecal__cell--selected");

                  console.log(vueCallCellsSelected)
                  console.log(getKeyByValue(myArray, vueCallCellsSelected));
                }, 300);
                */

                if (this.$selectedSlot) {
                    var refsItem = this.$refs['slot-' + this.$selectedSlotId];

                    if (refsItem) {
                        refsItem.classList.remove('selected_event');
                    }

                    this.$store.dispatch('unblockServiceSlot', {
                        slot_id: this.$selectedSlot
                    });

                    this.slotReservationCountdown = moment(180 * 10 * 1000);
                }

                this.$selectedSlotId = event.id;
                this.$selectedSlot = event.id_origin;
                this.$selectedSlotDate = event.slot_date;

                this.$refs['slot-' + event.id].classList.add('selected_event');

                setTimeout(() => {
                    this.$store.dispatch('blockServiceSlot', {
                        slot_id: this.$selectedSlot,
                        blocked_date: this.$selectedSlotDate
                    });
                }, 500);

                this.slotReservationCountdown = moment(180 * 10 * 1000);

                if (!this.enabledSlotReservationCounter) {
                    setInterval(() => {
                        this.slotReservationCountdown = moment(this.slotReservationCountdown.subtract(1, 'seconds'))
                    }, 1000);

                    this.enabledSlotReservationCounter = true;
                }
            },

            customEventCreation(value) {
                this.$refs.vuecal.createEvent(
                    value.start,
                    120, // event duration
                    {
                        title: value.title,
                        content: value.content,
                        class: 'blue-event'
                    }
                );
            },

            clickedPrevCal() {
                if (this.$selectedSlotId) {
                    setTimeout(() => {
                        var slotElementsPrev = document.querySelectorAll('*[id^="slot-"]');

                        for (var i = 0; i < slotElementsPrev.length; i++) {
                            slotElementsPrev[i].classList.remove('selected_event');

                            if (slotElementsPrev[i].id.includes(this.$selectedSlotId)) {
                                slotElementsPrev[i].classList.add('selected_event');
                            }
                        }
                    }, 300);
                }
            },

            clickedNextCal() {
                if (this.$selectedSlotId) {
                    setTimeout(() => {
                        var slotElementsNext = document.querySelectorAll('*[id^="slot-"]');

                        for (var i = 0; i < slotElementsNext.length; i++) {
                            slotElementsNext[i].classList.remove('selected_event');

                            if (slotElementsNext[i].id.includes(this.$selectedSlotId)) {
                                slotElementsNext[i].classList.add('selected_event');
                            }
                        }
                    }, 300);
                }
            },

            onUpdatePhoneNumber(payload) {
                this.phoneNumberResults = payload;
            },
        }
    }
</script>

<style lang="scss">
    .vuecal__title {
        font-family: 'Raleway', sans-serif;
        font-size: 16px;
        font-weight: bold;
    }

    .vuecal__cell-events {
        padding: 5px;
    }

    .vuecal__event {
        background: #28a745;
        color: white;
        cursor: pointer;
        font-family: 'Raleway', sans-serif;
        font-weight: bold;
        font-size: 14px;

        border-radius: 5px;
        border: 1px solid #dce0e7;

        margin-top: 5px;
        /*padding-top: 10px;*/
        /*padding-bottom: 10px;*/
    }

    .vuecal__event-title {
        width: 100%;
        height: 100%;
        padding: 10px;
    }

    .vuecal__event-title span {
        display: block;
        font-size: 11px;
    }

    .vuecal__event--focus {
        color: white;
        //background: #c8017d;
    }

    .vuecal__no-event {
        display: none;
    }

    .vuecal__flex {
        font-family: 'Raleway', sans-serif;
        font-size: 14px;
        font-weight: bold;
    }

    .vuecal__title-bar {
        background-color: #e2e2e2;
    }

    .vuecal__cell--today, .vuecal__cell--current {
        background-color: transparent;
        border: 1px solid black;
    }

    .vuecal:not(.vuecal--day-view) .vuecal__cell--selected {
        background-color: transparent;
    }


    .vuecal__cell--highlighted:not(.vuecal__cell--has-splits),
    .vuecal__cell-split--highlighted {
        background-color: rgba(195, 255, 225, 0.5);
    }

    .vuecal__arrow.vuecal__arrow--highlighted,
    .vuecal__view-btn.vuecal__view-btn--highlighted {
        background-color: rgba(136, 236, 191, 0.25);
    }

    .selected_event {
        background: #c8017d;
    }

    /* Small only */
    @media screen and (max-width: 39.9375em) {
        .vuecal__event-title {
            color: transparent;
        }
    }


    div.vue-phone-number-input {
        margin: 0 0 1rem;
    }

    div.select-country-container {
        z-index: 2;

        label {
            font-size: 11px !important;
        }

        .align-center {
            -webkit-box-align: center !important;
            -ms-flex-align: center !important;
            align-items: center !important;
            justify-content: left !important;
        }
    }

    div.input-tel {
        .input-tel__label {
            font-size: 11px !important;
        }
    }

    .country-selector__list {
        height: 60px !important;
    }
</style>
